// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","input":"Input__input--_p","multiline":"Input__multiline--ex"};